'use strict';
import {Injectable,Inject} from 'ng-metadata/core';
import {getCitationConfiguration, getVid, getBackendSystem} from '../appConfig/appConfigForward';

const get = require('lodash/get');
const CSL= require('citeproc');
const cloneDeep = require('lodash/cloneDeep');

@Injectable()
export class CslUtils {
	
	private CITATION_API_URL: string;
	
	private typeToCslType = {
			"newspaper": "book",
			"journal": "book",
			"newspaper_article": "article-newspaper",
			"article": "article-journal",
			"text_resource": "book",
			"government_document": "book",
			"image": "graphic",
			"map": "map",
			"score": "musical_score",
			"video": "motion_picture",
			"audio": "broadcast",
			"database": "book",
			"website": "webpage",
			"manuscript": "manuscript",
			"conference_proceeding": "paper-conference",
			"dissertation": "thesis",
			"kit": "book",
			"collection": "book",
			"other": "book",
			"archival_material": "book",
			"realia": "book",
			"book": "book",
			"book_chapter": "chapter",
			"case": "legal_case",
			"computer_file": "book",
			"dataset": "dataset",
			"legal_document": "legislation",
			"magazine_article": "article-magazine",
			"market_research": "article",
			"newsletter": "article",
			"pamphlet": "pamphlet",
			"paper": "paper-conference",
			"patent": "patent",
			"photograph": "graphic",
			"play": "book",
			"poem": "book",
			"reference_entry": "entry",
			"report": "report",
			"research_dataset": "dataset",
			"review": "review",
        	"standard": "book",
        	"statistical_dataset": "dataset",
        	"student_thesis": "thesis",
        	"technical_report": "report",
        	"trade_publication_article": "article",
        	"transcript": "article"
		}
		
    constructor(@Inject('$http') private $http: ng.IHttpService,
				@Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('restBaseURLs') restBaseURLs) {
		this.CITATION_API_URL = restBaseURLs.pushToBaseURL + '/citation/data' + (getBackendSystem() === 'suprima' ? '/' + getVid() : '');
	}

	public getCitation(pnx, style, delivery, source) {
		let docLang = get(pnx,'display.language');
		if (angular.isArray(docLang)) {
            docLang = docLang[0];
        }
		this.getCslFromServer(style, pnx, delivery, source)
            .then((response) => {this.handleCslData(response, style, docLang)}, (response) => console.error(response));
	}
	
	public handleCslData(response, style, docLang) {
		let itemsArray = [];
		let citations = [];

		let citationID = 'SXDNEKR5AD';
		let itemID = '2kntpabvm2';

		citations = citations.concat(this.createCitationJson(citationID,itemID));
		itemsArray = itemsArray.concat(this.createItemJsonFromServer(response,itemID));
		let items1 = {};
		items1[itemsArray[0].id] = itemsArray[0];
		let style_file = get(getCitationConfiguration(),'styles.'+style);

		if (docLang && docLang.length >=3) {
			docLang = docLang.substring(0,3);
			if (docLang != 'eng') {
				let loc = new Intl.Locale(docLang);
				docLang = loc.language;
				let locales = getCitationConfiguration().locales;
				Object.keys(locales).forEach((key) =>{
					if (key.startsWith(docLang)) {
						docLang = key;
					}
				});
		
			}
		}
		

		let citeprocSys = {
		    // Given a language tag in RFC-4646 form, this method retrieves the
		    // locale definition file.  This method must return a valid *serialized*
		    // CSL locale. (In other words, an blob of XML as an unparsed string.  The
		    // processor will fail on a native XML object or buffer).
		    retrieveLocale: function (lang) {
				let locale_file = get(getCitationConfiguration(),'locales.'+lang);
				if (!locale_file) {
					console.error('missing locale file for language '+lang+'. Using default (en-US)');
					locale_file = get(getCitationConfiguration(),'locales.en-US');
				}
				return locale_file;
		    },
		
		    // Given an identifier, this retrieves one citation item.  This method
		    // must return a valid CSL-JSON object.
		    retrieveItem: function(id){
		        return items1[id];
		    }
		};
		let citeproc = new CSL.Engine(citeprocSys,style_file,docLang);
		let citationParams = citations[0];
		citeproc.processCitationCluster(citationParams[0], citationParams[1], [])[1];

		let finalCitation = citeproc.makeBibliography();
		let data = {
			citation		: finalCitation[0].bibstart + finalCitation[1] + finalCitation[0].bibend,
			data			: finalCitation[1],
			entrySpacing	: finalCitation[0].entryspacing,
			hangingIndent	: finalCitation[0].hangingindent,
			lineSpacing		: finalCitation[0].linespacing,
			maxOffset		: finalCitation[0].maxoffset,
			secondFieldAlign: finalCitation[0]['second-field-align']
		}
		return data;
	}
	
	private createItemJsonFromServer(response,itemID) {
		let item = response.data;

		/* 	URM-209344
			after URM-167083 - OTB APA 7th style has no initial for names with full stop and no indenting for 2nd line
		 */
		if (item.author && angular.isArray(item.author)) {
			for(let i=0; i<item.author.length; i++) {
				if (item.author[i].given && item.author[i].given.slice(-1) == '.') {
					item.author[i].given = item.author[i].given.slice(0, -1);
				}
			}
		}

		delete item.beaconO22;
		item.id = itemID;
		let cslItem = [item];
		return cslItem;
	}
	
	public getCslFromServer(style, pnx, delivery, source) {
		let payload = {
            'style': style,
            'pnx': pnx,
            //'debug': this.$stateParams['debug'],
            'delivery': delivery,
            //'vid': this.vid,
            'source': source
        };
        return this.$http.post(this.CITATION_API_URL, payload);

	}
	private createCitationJson(citationID, itemID) {
		let citation = [[
		    {
		      "citationID": citationID,
		      "citationItems": [
		        {
		          "id": itemID
		        }
		      ],
		      "properties": {
		        "noteIndex": 1
		      }
		    },
		    [],
		    []
		  ]
		];
		return citation;
	}
	
	
	private getCslType(type) {
		return this.typeToCslType[type];
    }


}





// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/cslUtils.service.ts